import { eventBus } from '@tools/event-bus';
import { createApp } from 'vue';
import VirtualVisitComponent from './offer/virtual-visit-component.vue';

export const initVirtualvisit = () => {
  if (document.querySelector('.virtualvisit') === null) {
    return;
  }

  const component = {
    components: {
      VirtualVisitComponent,
    },
    data() {
      return {
        isVirtualVisitModalOpened: false,
      };
    },
    mounted() {
      eventBus.addEventListener('virtualvisit-open', () => {
        this.showVirtualVisitModal();
      });
    },
    methods: {
      /**
       * showVirtualVisitModal
       *
       * @description Show Gallery Modal
       */
      showVirtualVisitModal() {
        this.isVirtualVisitModalOpened = true;
      },
      /**
       * closeVirtualVisitModal
       *
       * @description Hide VirtualVisit Modal
       */
      closeVirtualVisitModal() {
        this.isVirtualVisitModalOpened = false;
      },
    },
  };

  createApp(component).mount('.virtualvisit');
};
